<template>
    <div class="company-table-container">
        <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
            <b-table 
                :items="companyList"
                :fields="tableFields" 
                class="company-table"
                borderless hover sticky-header
                @row-clicked="selectCompany"
                :busy="loadingCompanies"
                show-empty
                table-busy>
                <template #empty="">
                    <span class="empty-table-text" v-translate>No companies found</span>
                </template>
                <template #table-busy="">
                    <b-skeleton-table :rows="4" :columns="2" :table-props="{ bordered: false }" :hide-header="true" />
                </template>
            </b-table>
        </overlay-scrollbars>
        
        <div v-if="companyList.length" class="nav-btns">
          <GekkoButton 
              @click="prevResultsPage()" 
              :text="$gettext('Prev')" 
              class="pagination-button" 
              icon="fa-solid fa-arrow-left"
              variant="link"
              :class="prevPageButtonVariant"
          />
          <div class="nav-separator">|</div>
          <GekkoButton 
              @click="nextResultsPage()" 
              :text="$gettext('Next')" 
              :icon-right="true"
              icon="fa-solid fa-arrow-right"
              class="pagination-button"
              variant="link" 
              :class="nextPageButtonVariant"
          />
        </div>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import CompanyService from "@/store/services/company.service";

export default {
    name: "KvkSuggestionsTable",
    components: {GekkoButton},
    props: {
      companyName: {
        type: String,
        default: ''
      }
    },
    data() {
        return {
            tableFields: [
              { key: "kvkNummer", label: this.$gettext('KVK')},
              { key: "handelsnaam", label: this.$gettext('Name')},
              { key: "plaats", label: this.$gettext('City')}
            ],
            companyList: [],
            prevPageLink: null,
            nextPageLink: null,
            loadingCompanies: true
        }
    },
    methods: {
        selectCompany(company) {
            this.$emit("companySelected", company);
        },
        getCompanyList() {
          this.loadingCompanies = true;
          let params = {searchText: this.companyName};
          
          CompanyService.searchKvk(params).then((response) => {
            if (response.data.resultaten) {
              this.processSearchResponse(response.data);
            } else {
              this.loadingCompanies = false;
            }
          }).catch(() => {
            this.$store.commit('setAlert', {
                title: this.$gettext("Error"),
                text: this.$gettext("We could not find any results from your search."),
                variant: "danger",
                duration: 4
            });
          });
        },
        processSearchResponse(data) {
          if (data.resultaten) {
            this.companyList = data.resultaten;
            
            if (data.vorige)
              this.prevPageLink = data.vorige;
            else
              this.prevPageLink = null;

            if (data.volgende)
              this.nextPageLink = data.volgende;
            else
              this.nextPageLink = null;
          } else {
            this.companyList = [];
          }

          this.loadingCompanies = false;
        },
        prevResultsPage() {
          if (this.prevPageLink) {
            this.loadingCompanies = true;
            let params = {url: this.prevPageLink};
            CompanyService.getKvkPageByUrl(params).then((response) => {
              this.processSearchResponse(response.data);
            });
          }
        },
        nextResultsPage() {
          if (this.nextPageLink) {
            this.loadingCompanies = true;
            let params = {url: this.nextPageLink};
            CompanyService.getKvkPageByUrl(params).then((response) => {
              this.processSearchResponse(response.data);
            });
          }
        },
        clearCompanyList() {
          this.companyList = [];
        }
    },
    computed: {
        prevPageButtonVariant() {
            if (this.prevPageLink) return "primary";
            else return "disabled";
        },
        nextPageButtonVariant() {
            if (this.nextPageLink) return "primary";
            else return "disabled";
        },
    }
}
</script>

<style lang="scss">
.company-table-container {
  .os-host {
    border: 1px solid #c0c0c5;
    box-shadow: $dropdownShadow;
    border-radius: 12px;
    height: calc(100% - 36px) !important;
    .os-content { padding: 0 !important; }
    margin-bottom: 0.25rem !important;
  }
}

.company-table-container {
  flex: 1;
}

.company-table {
  cursor: pointer;
  font-size: 16px;
  min-height: 150px;
  overflow: visible !important;
  thead {
    font-size: 14px;
    tr {
      th {
        background: #f8f8f8 !important;
      }
    }
  }
  tr {
    th, td {
      padding: 0.5rem 0.75rem;
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid $colorBorderDash;
    }
  }
}

.nav-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    .nav-disabled { opacity: 0.4; }
    .nav-separator { opacity: 0.5; }
}
</style>